import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import ContactIcon from "@mui/icons-material/PhoneCallback";
import ReportGmailerrorredRoundedIcon from "@mui/icons-material/ReportGmailerrorredRounded";
import UsedIcon from "@mui/icons-material/SyncProblem";
import SearchingIcon from "@mui/icons-material/Troubleshoot";
import HandshakeIcon from "@mui/icons-material/VolunteerActivism";
import { Backdrop, Box, Button, Grid } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { darken, lighten, useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import gtag from "ga-gtag";
import { v4 as uuid } from "uuid";

import constants from "../../assets/constants";
import * as OnboardingSessionActions from "../../state/redux/onboardingSession";
import { deepCopyObject, isValidEmail } from "../../utils/helpers";
import OmniSpinner from "../ui/omniSpinner";
import OmniTextField from "../ui/omniTextField";
import Widget from "../ui/widget";
import WidgetContent from "../ui/widgetContent";
import WidgetFooter from "../ui/widgetFooter";
import WidgetTitle from "../ui/widgetTitle";

const UserOnboarding = props => {
  const {
    onboardingODM,
    organizationODM,
    onboardingStatus,
    inviteKey,
    // assessmentODM,
    // onboardingProctorODM,
    // onboardingSubjectODM,
    // onboardingAssessmentType,
    userODM,
  } = props;

  const [localOnboardingODM, setLocalOnboardingODM] = useState(null);

  const [readyOk, setReadyOk] = useState(false);

  const [userName, setUserName] = useState("");
  const [userNameValid, setUserNamevalid] = useState(false);
  useEffect(() => {
    userName.length > 0 ? setUserNamevalid(true) : setGivenNameValid(false);
  }, [userName]);

  const [givenName, setGivenName] = useState("");
  const [givenNameValid, setGivenNameValid] = useState(false);
  useEffect(() => {
    givenName.length > 0 ? setGivenNameValid(true) : setGivenNameValid(false);
  }, [givenName]);

  const [familyName, setFamilyName] = useState("");
  const [familyNameValid, setFamilyNameValid] = useState(false);
  useEffect(() => {
    familyName.length > 0 ? setFamilyNameValid(true) : setFamilyNameValid(false);
  }, [familyName]);

  const [email, setEmail] = useState("");
  const [emailValid, setEmailValid] = useState(false);
  useEffect(() => {
    email.length > 0 && isValidEmail(email) ? setEmailValid(true) : setEmailValid(false);
  }, [email]);

  // const [sendingRequest, setSendingRequest] = useState(true);
  const [sendingRequest, setSendingRequest] = useState(false);

  const [onboardingError, setOnboardingError] = useState(null);

  const smallScreen = useMediaQuery(theme => theme.breakpoints.down("sm"));
  const theme = useTheme();

  // const updateLocalUserData = event => {
  //   try {
  //     localOnboardingODM.omniData.userData[event.target.id] = event.target.value;

  //     setLocalOnboardingODM(deepCopyObject(localOnboardingODM));
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  useEffect(() => {
    givenNameValid && familyNameValid && userNameValid && emailValid
      ? setReadyOk(true)
      : setReadyOk(false);
  }, [givenNameValid, familyNameValid, userNameValid, emailValid]);

  useEffect(() => {
    if (onboardingODM != null) {
      //TODO add a shit ton of error handling try/catch
      let newODM = deepCopyObject(onboardingODM);
      if (newODM.omniData.inviteType === constants.inviteType.shared) {
        newODM.omniData.userData.familyName = "";
        newODM.omniData.userData.givenName = "";
        newODM.omniData.userData.displayName = "";
        newODM.omniData.userData.mobilePhone = "";
        newODM.omniData.userData.email = "";
      }
      setLocalOnboardingODM(newODM);
    } else {
      // //use the default "user Info for now, but this should really clear the data
      // //TODO make the redux sate load a fake one from above

      setLocalOnboardingODM(null);
    }
  }, [onboardingODM]);

  const [bannerImage, setBannerImage] = useState(null);
  const [postAssessmentHTML, setPostAssessmentHTML] = useState(null);
  const [onboardingHTML, setOnboardingHTML] = useState(null);

  useEffect(() => {
    if (organizationODM != null) {
      if (organizationODM.omniData.onboardingBanner) {
        setBannerImage(organizationODM.omniData.onboardingBanner);
      }
      if (organizationODM.omniData.onboardingHTML) {
        setOnboardingHTML(organizationODM.omniData.onboardingHTML);
      } else if (onboardingODM !== null && onboardingODM.omniData.onboardingHTML !== null) {
        setOnboardingHTML(onboardingODM.omniData.onboardingHTML);
      }

      if (organizationODM.omniData.postAssessmentHTML) {
        setPostAssessmentHTML(organizationODM.omniData.postAssessmentHTML);
      } else if (onboardingODM !== null && onboardingODM.omniData.postAssessmentHTML !== null) {
        setPostAssessmentHTML(onboardingODM.omniData.postAssessmentHTML);
      }
    }
  }, [organizationODM, onboardingODM]);

  const defaultRedrectTimeout = 5;
  const [redirectTimer, setRedirectTimer] = useState(defaultRedrectTimeout);

  useEffect(() => {
    if (redirectTimer === 0 && !userODM) {
      //Redirect to Login
      // var originURL = window..locationorigin;
      // window.location.href = `${originURL}/`;
    }
  }, [redirectTimer, userODM]);

  useEffect(() => {
    if (sendingRequest && userODM) {
      setSendingRequest(false);
    } else if (
      !sendingRequest &&
      userODM &&
      organizationODM.omniData.organizationType !== constants.organizationTypeEnums.omnisicaHealth
    ) {
      //Redirect to Login
      var originURL = window.location.origin;
      window.location.href = `${originURL}/`;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendingRequest, setSendingRequest, userODM]);

  useEffect(() => {
    if (onboardingStatus != null) {
      // Think we'd rather have a catch all gtag here for the time being
      // instead of
      if (onboardingStatus.errorCode) {
        gtag("event", "omni_onboarding_error", {
          errorCode: `${onboardingStatus.errorCode}`,
          errorText: `${onboardingStatus.errorText}`,
        });
      }

      if (onboardingStatus.errorCode === 400 && onboardingStatus.errorText.includes("completed")) {
        setTimeout(() => {
          setRedirectTimer(prevTimer => (prevTimer === 0 ? defaultRedrectTimeout : prevTimer - 1));
        }, 1000);
      } else if (
        onboardingStatus.errorCode === 400 &&
        onboardingStatus.errorText.includes("UsernameExistsException")
      ) {
        setOnboardingError("userNameExists");
        setSendingRequest(false);
      }
    }
  }, [onboardingStatus, redirectTimer, setRedirectTimer, userODM]);

  const onboardUserHandler = () => {
    //this is only called from below, and is guarded
    setSendingRequest(true);

    let finalOnboardingODM = deepCopyObject(localOnboardingODM);

    if (finalOnboardingODM.omniData.userData.hasOwnProperty("businessPillar")) {
      finalOnboardingODM.omniData.userData.businessPillar = "personnel";
    }

    // // this shit is a proxy so we could move over the stuff below
    finalOnboardingODM.omniData.userData.displayName = `${givenName} ${familyName}`;
    finalOnboardingODM.omniData.userData.givenName = givenName;
    finalOnboardingODM.omniData.userData.familyName = familyName;
    finalOnboardingODM.omniData.userData.email = email;
    finalOnboardingODM.omniData.userData.mobilePhone = "(555)555-5555";

    finalOnboardingODM.omniData["credentials"] = {
      password: `${uuid()}mak3Val1d!`,
      username: userName,
    };

    gtag("event", "omni_onboarding_complete", {
      invite_key: inviteKey,
    });

    props.onboardUserRequest({
      onboardingODM: finalOnboardingODM,
      assessmentODM: null,
      onboardingProctorODM: null,
      onboardingSubjectODM: null,
      passiveOnboard: false,
    });
  };

  const mobileLayout = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Widget widgetSize="medium" allowShrink={false}>
      {!bannerImage && <WidgetTitle title={"Welcome"} text={"Account Creation"}></WidgetTitle>}
      {bannerImage && <Box>{bannerImage}</Box>}

      {/*user exists - show post onboarding or guard testers*/}
      {userODM &&
        !sendingRequest &&
        organizationODM.omniData.organizationType ===
          constants.organizationTypeEnums.omnisicaHealth && (
          <WidgetContent noMargins={true} footer={true}>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                padding: theme.spacing(2),
                paddingRight: theme.spacing(1),
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",

                  overflowY: "auto",
                  "&::-webkit-scrollbar": {
                    width: theme.spacing(2),
                    borderRadius: theme.spacing(1),
                  },
                  "&:hover::-webkit-scrollbar": {
                    width: theme.spacing(2),
                  },
                  "&::-webkit-scrollbar-track": {
                    borderRadius: theme.spacing(1),
                    backgroundColor: darken(theme.palette.commonground.main, 0.4),
                    backgroundClip: "content-box",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    opacity: "0.5",
                    borderRadius: theme.spacing(1),
                    backgroundColor: theme.palette.secondary.main,
                  },
                  "&:hover::-webkit-scrollbar-thumb": {
                    backgroundColor: lighten(theme.palette.secondary.main, 0.2),
                  },
                }}
              >
                {/* default message */}
                {!postAssessmentHTML && (
                  <Grid container justifyContent={"center"}>
                    <Grid
                      container
                      xs={12}
                      spacing={1}
                      alignContent={"center"}
                      justifyContent={"center"}
                    >
                      <Grid xs={12}>
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                          }}
                        >
                          <Typography variant={"h4"} sx={{ fontWeight: "bold" }}>
                            You're all done! What now?
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid xs={12}>
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            marginTop: theme.spacing(2),
                          }}
                        >
                          <SearchingIcon color="primary" fontSize="large" />
                          <Typography
                            variant={"h5"}
                            sx={{ marginTop: theme.spacing(0.25), marginLeft: theme.spacing(1) }}
                          >
                            Relax while we check your results
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid xs={12} alignItems={"center"}>
                        <Typography variant={"body1"} sx={{ textAlign: "center" }}>
                          We check our network for the best matches to your health profile.
                        </Typography>
                      </Grid>

                      <Grid xs={12}>
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            marginTop: theme.spacing(2),
                          }}
                        >
                          <ContactIcon color="primary" fontSize="large" />
                          <Typography
                            variant={"h5"}
                            sx={{ marginTop: theme.spacing(0.25), marginLeft: theme.spacing(1) }}
                          >
                            Keep an eye on your phone
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid xs={12} alignItems={"center"}>
                        <Typography variant={"body1"} sx={{ textAlign: "center" }}>
                          We will contact you and share the results.
                        </Typography>
                      </Grid>

                      <Grid xs={12}>
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            marginTop: theme.spacing(2),
                          }}
                        >
                          <HandshakeIcon color="primary" fontSize="large" />
                          <Typography
                            variant={"h5"}
                            sx={{
                              marginTop: theme.spacing(0.25),
                              marginLeft: theme.spacing(1),
                            }}
                          >
                            Share with Others
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid xs={12} alignItems={"center"}>
                        <Typography
                          variant={"body1"}
                          sx={{ textAlign: "center", marginBottom: theme.spacing(1) }}
                        >
                          Let your friends and family know about this free service
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                )}

                {postAssessmentHTML && (
                  <iframe
                    src={postAssessmentHTML}
                    frameBorder="0"
                    height={"100%"}
                    title="Special Onboarding Message"
                  />
                )}
              </Box>

              <Button
                variant={"contained"}
                sx={[
                  mobileLayout && { boxShadow: theme.shadows[3] },
                  {
                    boxShadow: theme.shadows[3],
                    marginLeft: theme.spacing(4),
                    marginRight: theme.spacing(4),
                    padding: theme.spacing(3),
                    display: "flex",
                    alignSelf: "center",
                    width: "calc(100% - 64px)",
                    borderRadius: theme.spacing(2),
                    marginTop: theme.spacing(1),
                  },
                ]}
                onClick={e => {
                  e.stopPropagation();
                  gtag("event", "omni_onboarding_navigate_to_portal_click", {
                    invite_key: `${inviteKey}`,
                  });

                  var originURL = window.location.origin;
                  window.location.href = `${originURL}/`;
                }}
              >
                <Typography variant="h4">{"Show me more"}</Typography>
              </Button>
            </Box>

            <WidgetFooter />
          </WidgetContent>
        )}

      {/*no user */}
      {!userODM && (
        <WidgetContent noMargins={true} footer={true} sx={{ maxWidth: "200px" }}>
          {/* waiting to load the onboarding */}
          {localOnboardingODM == null && (
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                position: "relative",
                padding: theme.spacing(4),
                paddingTop: theme.spacing(2),
                paddingBottom: "0",
                userSelect: "none",
              }}
            >
              <Grid
                container
                spacing={1}
                direction="row"
                justifyContent="flex-start"
                alignItems={"stretch"}
              >
                <Grid xs={12}>
                  <Typography
                    variant={"h5"}
                    sx={{
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    {!onboardingStatus
                      ? "Looking for your invitation"
                      : onboardingStatus.errorCode === 404
                        ? `${onboardingStatus.errorText}`
                        : `${onboardingStatus.errorCode} - ${onboardingStatus.errorText}`}
                  </Typography>
                </Grid>
                <Grid xs={12}>
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                    }}
                  >
                    {onboardingStatus ? (
                      <ReportGmailerrorredRoundedIcon
                        sx={{
                          width: "220px",
                          height: "220px",
                          textAlign: "center",
                          color: theme.palette.secondary.main,
                        }}
                      />
                    ) : (
                      <OmniSpinner size={237} fillcolor={theme.palette.secondary.main} />
                    )}
                  </Box>
                </Grid>
                <Grid xs={12}>
                  <Typography
                    variant={"h4"}
                    sx={{
                      width: "100%",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    {!onboardingStatus
                      ? "( Please be patient )"
                      : onboardingStatus.errorCode === 404
                        ? "We can't find your invitation"
                        : `${onboardingStatus.errorCode} - ${onboardingStatus.errorText}`}
                  </Typography>
                  <Grid xs={12}>
                    <Typography
                      variant={"h5"}
                      sx={{
                        width: "100%",
                        textAlign: "center",
                        marginTop: theme.spacing(0.5),
                      }}
                    >
                      {!onboardingStatus
                        ? " "
                        : onboardingStatus.errorCode === 404
                          ? "You can request another another one on our website"
                          : `${onboardingStatus.errorCode} - ${onboardingStatus.errorText}`}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Button
                variant={"contained"}
                sx={[
                  mobileLayout && { boxShadow: theme.shadows[3] },
                  {
                    boxShadow: theme.shadows[3],
                    marginLeft: theme.spacing(4),
                    marginRight: theme.spacing(4),
                    padding: theme.spacing(3),
                    display: "flex",
                    alignSelf: "center",
                    width: "calc(100% - 64px)",
                    borderRadius: theme.spacing(2),
                    position: "absolute",
                    bottom: theme.spacing(2),
                    marginTop: theme.spacing(1),
                  },
                  !onboardingStatus && {
                    visibility: "hidden",
                  },
                ]}
                onClick={e => {
                  e.stopPropagation();
                  gtag("event", "omni_onboarding_navigate_to_contactus_click", {
                    invite_key: `${inviteKey}`,
                  });
                  window.location.replace("https://www.omnisciahealth.com/contact-us");
                }}
              >
                <Typography variant="h4">{"Request Invitation"}</Typography>
              </Button>
            </Box>
          )}

          {/*sad path */}
          {localOnboardingODM != null &&
            (!localOnboardingODM.omniAudit.isActive ||
              localOnboardingODM.omniData.invitationStatus !== "created") && (
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  position: "relative",
                  padding: theme.spacing(4),
                  paddingTop: theme.spacing(2),
                  paddingBottom: "122px",
                  userSelect: "none",
                }}
              >
                <Grid
                  container
                  spacing={1}
                  direction="row"
                  justifyContent="flex-start"
                  alignItems={"stretch"}
                >
                  <Grid xs={12}>
                    <Typography
                      variant={"h5"}
                      sx={{
                        width: "100%",
                        // fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      Sorry, this invitation is no longer valid.
                    </Typography>
                  </Grid>
                  <Grid xs={12}>
                    <Box
                      sx={{
                        width: "100%",
                        height: "100%",
                        textAlign: "center",
                      }}
                    >
                      <UsedIcon
                        sx={{
                          width: "220px",
                          height: "220px",
                          textAlign: "center",
                          color: theme.palette.secondary.main,
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid xs={12}>
                    <Typography
                      variant={"h4"}
                      sx={{
                        width: "100%",
                        fontWeight: "bold",
                        textAlign: "center",
                      }}
                    >
                      Don't worry, we have an invitation for you.
                    </Typography>
                    <Grid xs={12}>
                      <Typography
                        variant={"h5"}
                        sx={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: theme.spacing(0.5),
                        }}
                      >
                        Just click the button below to get started.
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Button
                  variant={"contained"}
                  sx={[
                    mobileLayout && { boxShadow: theme.shadows[3] },
                    {
                      boxShadow: theme.shadows[3],
                      marginLeft: theme.spacing(4),
                      marginRight: theme.spacing(4),
                      padding: theme.spacing(3),
                      display: "flex",
                      alignSelf: "center",
                      width: "calc(100% - 64px)",
                      borderRadius: theme.spacing(2),
                      position: "absolute",
                      bottom: theme.spacing(2),
                    },
                  ]}
                  // disabled={!organizationODM.omniData.sharedInviteKey}
                  disabled={true}
                  onClick={e => {
                    e.stopPropagation();
                    gtag("event", "omni_onboarding_navigate_to_default_invite_click", {
                      invite_key: `${inviteKey}`,
                    });

                    let onboardUrl = `${window.location.origin}/onboarding?inviteKey=${organizationODM.omniData.sharedInviteKey}`;
                    window.location.href = onboardUrl;
                  }}
                >
                  <Typography variant={smallScreen ? "h5" : "h4"}>
                    {"Click toasdd Start"}
                  </Typography>
                </Button>
              </Box>
            )}

          {/*happy path onboarding */}
          {localOnboardingODM != null &&
            localOnboardingODM.omniAudit.isActive &&
            localOnboardingODM.omniData.invitationStatus === "created" && (
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  padding: theme.spacing(2),
                  paddingRight: theme.spacing(1),
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",

                    overflowY: "auto",
                    "&::-webkit-scrollbar": {
                      width: theme.spacing(2),
                      borderRadius: theme.spacing(1),
                    },
                    "&:hover::-webkit-scrollbar": {
                      width: theme.spacing(2),
                    },
                    "&::-webkit-scrollbar-track": {
                      borderRadius: theme.spacing(1),
                      backgroundColor: darken(theme.palette.commonground.main, 0.4),
                      backgroundClip: "content-box",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      opacity: "0.5",
                      borderRadius: theme.spacing(1),
                      backgroundColor: theme.palette.secondary.main,
                    },
                    "&:hover::-webkit-scrollbar-thumb": {
                      backgroundColor: lighten(theme.palette.secondary.main, 0.2),
                    },
                  }}
                >
                  {/* default message */}
                  {!onboardingHTML && (
                    <Grid
                      container
                      spacing={1}
                      direction="row"
                      justifyContent="flex-start"
                      alignItems={"stretch"}
                      maxWidth={"600px"}
                    >
                      <Typography
                        variant={"overline"}
                        sx={{ marginBottom: `-${theme.spacing(1)}` }}
                      >
                        Tell us about yourself so we can create your account
                      </Typography>

                      <Grid size={{ xs: 6 }}>
                        <OmniTextField
                          label="First"
                          type="textInput"
                          name={uuid()} //prevents AutoComplete Suggestions
                          variant="outlined"
                          id={"givenName"}
                          value={givenName}
                          error={!givenNameValid}
                          onChange={event => {
                            event.target.value = event.target.value.trim();
                            setGivenName(event.target.value);
                          }}
                          placeholder={"First Name"}
                          required
                        />
                      </Grid>

                      <Grid size={{ xs: 6 }}>
                        <OmniTextField
                          label="Last"
                          type="textInput"
                          name={uuid()} //prevents AutoComplete Suggestions
                          variant="outlined"
                          id={"familyName"}
                          value={familyName}
                          error={!familyNameValid}
                          onChange={event => {
                            event.target.value = event.target.value.trim();
                            setFamilyName(event.target.value);
                          }}
                          placeholder={"Last Name"}
                          required
                        />
                      </Grid>

                      <Grid size={{ xs: 12 }}>
                        <OmniTextField
                          label="Email"
                          type="textField"
                          name={uuid()} //prevents AutoComplete Suggestions
                          variant="outlined"
                          id={"email"}
                          value={email}
                          error={!emailValid}
                          onChange={event => {
                            setEmail(event.target.value);
                          }}
                          placeholder={"Primary Email Address"}
                          required={true}
                        />
                      </Grid>

                      <Grid size={{ xs: 12 }}>
                        <OmniTextField
                          label="User Name"
                          type="textField"
                          name={uuid()} //prevents AutoComplete Suggestions
                          variant="outlined"
                          id={"username"}
                          value={userName}
                          error={!userNameValid || onboardingError === "userNameExists"}
                          helperText={
                            onboardingError === "userNameExists"
                              ? "User name already exists. Please enter another user name ad click Create Account to try again."
                              : null
                          }
                          onChange={event => {
                            setOnboardingError(null);
                            setUserName(event.target.value.replace(/[^a-zA-Z]/g, ""));
                          }}
                          placeholder={"Your desired username"}
                          required={true}
                        />
                      </Grid>
                    </Grid>
                  )}
                </Box>
                {/* <Grid size={10} alignSelf={"center"}>
                  <OmniResponsiveButton
                    sx={{ width: "100%" }}
                    onClick={e => {
                      e.stopPropagation();
                      gtag("event", "omni_onboarding_start_click", {
                        invite_key: `${inviteKey}`,
                      });
                      onboardUserHandler();
                    }}
                    disabled={!readyOk}
                  />
                </Grid> */}
                <Button
                  variant={"contained"}
                  sx={[
                    mobileLayout && { boxShadow: theme.shadows[3] },
                    {
                      boxShadow: theme.shadows[3],
                      marginTop: theme.spacing(1),
                      padding: theme.spacing(2),
                      display: "flex",
                      alignSelf: "center",
                      width: "calc(100% - 64px)",
                      borderRadius: theme.spacing(2),
                    },
                  ]}
                  onClick={e => {
                    e.stopPropagation();
                    gtag("event", "omni_onboarding_start_click", {
                      invite_key: `${inviteKey}`,
                    });
                    onboardUserHandler();
                  }}
                  disabled={!readyOk}
                >
                  <Typography variant={smallScreen ? "h6" : "h5"}>{"Create Account"}</Typography>
                </Button>
                {sendingRequest && !userODM && (
                  <Backdrop
                    sx={{
                      color: "#fff",
                      backgroundColor: "rgba(0,0,0,0.8)",
                      zIndex: theme => theme.zIndex.drawer + 1,
                    }}
                    open={!userODM}
                  >
                    <Grid
                      container
                      direction={"column"}
                      justifyContent={"center"}
                      alignItems={"center"}
                    >
                      <Grid>
                        <Typography variant="h6">Please wait</Typography>
                      </Grid>
                      <Grid container xs={12} justifyContent={"center"} alignItems={"center"}>
                        <Grid>
                          <OmniSpinner size="150" />
                        </Grid>
                      </Grid>
                      <Grid>
                        <Typography variant="h6">
                          We're
                          {organizationODM.omniData.organizationType ===
                          constants.organizationTypeEnums.botpressTesting
                            ? ` creating your profile`
                            : ` saving your assessment`}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Backdrop>
                )}
              </Box>
            )}

          <WidgetFooter />
        </WidgetContent>
      )}
    </Widget>
  );
};

const mapStateToProps = state => ({
  onboardingODM: state.onboardingSession.onboardingODM,
  organizationODM: state.onboardingSession.organizationODM,
  onboardingStatus: state.onboardingSession.onboardingStatus,
  onboardingSuccess: state.onboardingSession.onboardingSuccess,
  onboardingAssessmentType: state.onboardingSession.onboardingAssessmentType,
  inviteKey: state.onboardingSession.inviteKey,
  assessmentODM: state.onboardingSession.assessmentODM,
  onboardingProctorODM: state.onboardingSession.onboardingProctorODM,
  onboardingSubjectODM: state.onboardingSession.onboardingSubjectODM,
  userODM: state.userSession.userODM,
});

const mapDispatchToProps = {
  onboardUserRequest: OnboardingSessionActions.onboardUserRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserOnboarding));
